<div class="new-query">
  <ng-container *ngIf="isAutehnticated">
    <div class="header">
      <h2>Justino v{{ jusVersion }}</h2>
    </div>
    <p><strong>¡Hola! Soy Justino, estoy aquí para ayudarte</strong></p>
    <div class="entities">
      <button (click)="sendMessage(1)">¿Le gustaría que le ayude a identificar qué tipo de demanda tiene que presentar?</button>
      <button (click)="sendMessage(2)">¿Quiere que le ayude a generar un borrador de la demanda?</button>       
    </div>
  </ng-container>
  <ng-container *ngIf="!isAutehnticated">
    <div [innerHTML]="codeIntro"></div>
  </ng-container>
</div>
